var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useIndicatorLayouts } from '../context/indicator-layouts-context';
import { IndicatorLayoutDefault } from '../indicator-layouts/indicator-layout-default';
import { indicatorHasValue } from '../utils/indicator-has-value';
var cls = classNames('indicator-group-layout-default');
var IndicatorGroupLayoutDefaultDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'IndicatorGroupLayoutDefault',
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var IndicatorGroupLayoutDefault = function (props) {
  var componentProps = useComponentProps(My.NAME, IndicatorGroupLayoutDefaultDefaultProps, props);
  var className = componentProps.className,
    entity = componentProps.entity;
  var indicatorLayouts = useIndicatorLayouts();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, entity.indicators.map(function (indicator, index) {
    var _a;
    var Layout = indicatorLayouts[(_a = indicator.layout) === null || _a === void 0 ? void 0 : _a.component] || IndicatorLayoutDefault;
    if (indicatorHasValue(indicator)) {
      return React.createElement(Layout, {
        key: index,
        entity: indicator
      });
    }
    return null;
  }));
};
IndicatorGroupLayoutDefault.cls = cls;
var templateObject_1, templateObject_2;